import styled from 'styled-components';

export const ContentListDownloadDataStyled = styled.div`
  > div {
    margin: 16px 0px 0px 0px;
  }

  > ul {
    padding-left: 30px;
    list-style-type: disc;
    li {
      display: list-item;
    }
  }

  > div:has(img) {
    margin-top: 8px;
  }

  p {
    color: #333333;
    font-size: 16px;
    margin-bottom: 0;
  }
`;
